import arriereBackoffice, {
  CustomFieldScope,
} from '@avantstay/arriere-clients/dist/arriereBackoffice'

import {
  CustomFieldInput,
  CustomFieldSectionInput,
  UpdateHomeCustomFieldProps,
} from '@arriere/types/CustomFields.types'

export const customFieldsFragment = {
  section: {
    id: true,
    name: true,
    readOnly: true,
  },
  fields: {
    id: true,
    kind: true,
    value: true,
    name: true,
    options: true,
    restriction: true,
    internal: true,
    listOrder: true,
    valueIsDefault: true,
    tags: true,
    createdAt: true,
    updatedAt: true,
    tooltip: true,
    lastUpdatedAt: true,
    lastUpdatedBy: {
      kind: true,
      name: true,
    },
    lastVerifiedAt: true,
    lastVerifiedBy: {
      kind: true,
      name: true,
    },
    assets: {
      id: true,
      context: true,
      s3Bucket: true,
      s3Key: true,
      public: true,
      targetId: true,
      createdAt: true,
      updatedAt: true,
      extension: true,
      size: true,
      fileName: true,
      url: true,
    },
    requiresVerification: true,
    userAllowedActions: true,
    requiredPrivileges: {
      name: true,
      category: true,
      action: true,
    },
  },
}

export const getCustomFieldConfigurationSections = async (scope: CustomFieldScope) => {
  return arriereBackoffice.queries.customFieldSections
    .raw({
      __args: {
        scope,
        readOnly: false,
      },
      __alias: 'getCustomFieldSections',
      id: true,
      name: true,
      scope: true,
      kind: true,
      listOrder: true,
      customFields: {
        customFieldSectionId: true,
        name: true,
        id: true,
        listOrder: true,
        kind: true,
        multipleValues: true,
        restriction: true,
        defaultValue: true,
        values: {
          value: true,
          listOrder: true,
        },
      },
    })
    .then(({ data, errors }) => {
      if (errors?.length) {
        throw new Error(errors[0]?.message)
      }

      return data
    })
}

export const getPropertyCustomFields = async (homeId: string) => {
  return arriereBackoffice.queries.home
    .raw({
      __alias: 'getCustomFields',
      __args: { homeId },
      customFields: {
        __args: { tags: undefined },
        ...customFieldsFragment,
      },
    })
    .then(({ data, errors }) => {
      if (errors?.length) {
        throw new Error(errors[0]?.message)
      }

      return data
    })
}

export const getConfigurationFields = async () => {
  return arriereBackoffice.queries.configurationFields
    .raw({
      __alias: 'getConfigurationFields',
      __args: { tags: [] },
      ...customFieldsFragment,
    })
    .then(({ data, errors }) => {
      if (errors?.length) {
        throw new Error(errors[0]?.message)
      }

      return data
    })
}

// Mutations

export const updateCustomFields = ({ customFields }: { customFields: CustomFieldInput[] }) => {
  return arriereBackoffice.mutations.updateCustomFields({
    __args: { customFields },
    id: true,
  })
}

export const updateCustomFieldSections = ({
  sections,
}: {
  sections: CustomFieldSectionInput[]
}) => {
  return arriereBackoffice.mutations.updateCustomFieldSections({
    __args: { sections },
    id: true,
    name: true,
    scope: true,
  })
}

export const updateHomeCustomField = ({ homeId, customFields }: UpdateHomeCustomFieldProps) => {
  return arriereBackoffice.mutations.updateHomeCustomFields({
    __args: { homeId, customFields },
  })
}
